import { LOADING_SET } from "./actionType";

export const loadingSet = (payload) => {
	return {
		type: LOADING_SET,
		payload,
	};
};

export const addAdmin = (registerInput) => (dispatch) => {
	dispatch(loadingSet(true));
	return fetch("https://terkini-rysaldi.herokuapp.com/admin/register", {
		method: "POST",
		body: JSON.stringify(registerInput),
		headers: {
			"Content-Type": "application/json",
			access_token: localStorage.access_token,
		},
	}).then(async (res) => {
		if (!res.ok) {
			const isJson = res.headers.get("content-type")?.includes("application/json");
			const data = isJson ? await res.json() : null;
			const error = (data && data.message) || res.status;
			return Promise.reject(error);
		}
	});
};

export const login = (loginInput) => (dispatch) => {
	dispatch(loadingSet(true));
	return fetch("https://terkini-rysaldi.herokuapp.com/admin/login", {
		method: "POST",
		body: JSON.stringify(loginInput),
		headers: {
			"Content-Type": "application/json",
		},
	}).then(async (res) => {
		if (!res.ok) {
			const isJson = res.headers.get("content-type")?.includes("application/json");
			const data = isJson ? await res.json() : null;
			const error = (data && data.message) || res.status;
			return Promise.reject(error);
		}

		return res.json();
	});
};
